<app-header
  #header
  (searchBarVisibleStatus)="searchBarMobileVisibleStatus($event)"
  ></app-header>
<section class="notd__grid wrapper--centered wrapper--organized main-lp-content">
  <section class="populat-categories" *ngIf="categoriesData && categoriesData.length">
    <ul class="populat-categories__list">
      <li class="populat-categories__list__category" *ngFor="let type of categoriesData;" id="category-{{type.type}}">
        <a [routerLink]="['/search', type.type, 'all']" class="populat-categories__list__category__label">{{type.typeLabel}}</a>
      </li>
    </ul>
  </section>
  <section class="create-note-wrapper" *ngIf="isLoggedIn">
    <create-note></create-note>
  </section>
  <section
    class="newest-section"
    *ngIf="!this.isMobile.value || (this.isMobile.value && this.isMobile.size !== 'sm')">
    <div class="headline-section">
      <a class="lp-headline-main" [routerLink]="['/search/all/all']" title="Latest notes">
        Latest on Notd
      </a>
      <div
        [ngClass]="{'show--bar': showSearchBarOnMobile}"
        class="search-bar">
        <search-content
          [props]="searchFormProps"
          [isPreviewMode]="true"
          [previewDefaultPhase]="'notd'"
          type="notes"></search-content>
      </div>
    </div>
    <streams-side-list
      [limit]="12"
      [display]="'windows'"
      [columns]="2"
      [notesImages]="true"
      [extendedList]="true"
      [showPlaceholders]="true"
      [outputList]="latestChannels"
      [listType]="streamTopListType">
    </streams-side-list>
  </section>

  <featured-notes
    *ngIf="!this.isMobile.value || (this.isMobile.value && this.isMobile.size !== 'sm')"
    [notes]="featuredNotes.notes"
    [showPlaceholders]="true"
    [showSearch]="false"
    [offset]="[0, 2]">
  </featured-notes>

  <section class="become-a-creator" *ngIf="!isLoggedIn">
    <span class="info">
      Anyone can publish for free on Notd - Sign up now in a minute
    </span>
    <button transact-auth [partnersModal]="notdPartnersModal">Sign-Up</button>
    <notd-partners-modal
      #notdPartnersModal
      [customReturnUrl]="{signup: {enable: true, url: 'info/signup-thankyou'}}"></notd-partners-modal>
  </section>

  <section
    class="mobile-content"
    *ngIf="this.isMobile.value && this.isMobile.size === 'sm'">
    <div
      [ngClass]="{'show--bar': showSearchBarOnMobile}"
      class="search-bar">
      <search-content
        [props]="searchFormProps"
        [isPreviewMode]="true"
        [previewDefaultPhase]="'notd'"
        type="notes"></search-content>
    </div>
    <section
      *ngIf="mobileContent.loading.global"
      class="mobile-content__loading">
      <span class="mobile-content__loading__spinner"></span>
      <p class="mobile-content__loading__label">Loading content...</p>
    </section>
    <div
      *ngIf="!mobileContent.loading.global && mobileContent.type === 'latest'"
      class="mobile-content__latest">
      <h2 class="mobile-content__headline">Latest on notd</h2>
      <div
        *ngFor="let n of mobileContent.notes"
        class="mobile-content__latest__note">
        <div class="mobile-content__latest__note__details">
          <h3 class="mobile-content__latest__note__details__stream">
            <img
                class="mobile-content__latest__note__details__stream__profile-img"
                *ngIf="n.user && n.user.profileImageUrl"
                [src]="n.user.profileImageUrl" />
            <a
              *ngIf="n.user"
              class="mobile-content__latest__note__details__stream__by-user"
              [routerLink]="['/user', n.userId, 'profile']"
              [title]="'Visit ' + (n.user.displayName || n.user.userDisplayName) + ' profile!'">
                {{n.user.displayName || n.user.userDisplayName || n.userDisplayName}}
            </a>
            <span class="mobile-content__latest__note__details__stream__separator">in</span>
            <!-- <img-lazy-loading
              class="mobile-content__latest__note__details__stream__img"
              *ngIf="n && n.user && n.user.profileImageUrl"
              [mainThumb]="n.user.profileImageUrl"
              [title]="'Check user profile ' + n.user.displayName ? n.user.displayName : n.user.userDisplayName"></img-lazy-loading>
              {{n.user.displayName ? n.user.displayName : n.user.userDisplayName}} -->
            <span class="mobile-content__latest__note__details__stream__title">{{n.channelName}}</span>
          </h3>
          <a
            [routerLink]="n.shortURLPath ? ['/n', n.shortURLPath] : ['/notes', n.id, n.indexedName || n.name || n.id]"
            class="mobile-content__latest__note__details__title">
            {{n.name}}
          </a>
          <span class="mobile-content__latest__note__details__date">
            {{n.updated || n.published | date: 'MMM dd, yyyy' }}
          </span>
          <div class="mobile-content__latest__note__details__tags">
            <span class="mobile-content__latest__note__details__tags__tag tag--free-note" *ngIf="n.price === 0">free note</span>
          </div>
        </div>
        <img-lazy-loading
          class="mobile-content__latest__note__img"
          *ngIf="n && n.thumbnails && n.thumbnailImage"
          [mainThumb]="n.thumbnailImage"
          [thumbs]="n.thumbnails"
          [title]="'Read more about ' + n.name"></img-lazy-loading>
      </div>
      <div
        *ngIf="
          this.isMobile.value && this.isMobile.size === 'sm' && this.mobileContent.showMoreBtn"
        class="load-more-content-wrapper">
        <button
          [ngClass]="{'loading': this.mobileContent.loading.loadMore}"
          [disabled]="this.mobileContent.loading.loadMore"
          class="load-more-button" (click)="loadMoreMobileContent()" i18n="@@GLOBAL-LOAD-MORE">Load More Notes</button>
      </div>
      <featured-notes
        *ngIf="featuredNotes.notes && featuredNotes.notes.length"
        [notes]="featuredNotes.notes"
        [showSearch]="true"
        [offset]="[0, 2]">
      </featured-notes>
    </div>
    <div
      *ngIf="!mobileContent.loading.global && mobileContent.type === 'popular'"
      class="mobile-content__popular">
      <h2 class="mobile-content__headline">Most popular</h2>
      <ng-container *ngTemplateOutlet="most_popular_stream"></ng-container>
      <div class="load-more-content-wrapper" *ngIf="featuredChannels.length > desktopContentSort.size">
        <button class="load-more-button" (click)="loadMoreFeaturedChannels()" i18n="@@GLOBAL-LOAD-MORE">Load More Streams</button>
      </div>
    </div>
  </section>

  <!-- left column -->
  <!-- <div class="column--left">
    <category-selector></category-selector>
  </div> -->
  <!-- central column lp -->
  <div
    class="column--center"
    *ngIf="!this.isMobile.value || (this.isMobile.value && this.isMobile.size !== 'sm')">
    <h2 class="lp-headline-main">Most popular streams</h2>
    <ng-container *ngTemplateOutlet="most_popular_stream"></ng-container>
    <div
      class="load-more-content-wrapper"
      *ngIf="!desktopContentSort.ended">
      <button class="load-more-button" (click)="loadMoreFeaturedChannels()" i18n="@@GLOBAL-LOAD-MORE">Load More Streams</button>
    </div>
  </div>
  <!-- right additional column lp -->
  <!-- <div class="column--right">
    <section class="become-a-creator" *ngIf="!isLoggedIn">
      <span class="info">
        Become a content creator and start making money.
      </span>
      <button transact-auth>Sign-Up</button>
    </section>
    <create-note></create-note>
    <div class="categories-section">
      <category-selector [theme]="'white'"></category-selector>
    </div>
    <followed-streams></followed-streams>
  </div> -->
</section>

<div class="sign-up-section" *ngIf="!isLoggedIn">
  <div class="content grid">
    <h2>Sign Up Now With <br/><a href="https://transact.io" class="logo" target="_blank" title="Transact.io"><img src="../../assets/transact_logo_white.png" alt="Sign Up Now With"></a></h2>
    <p i18n="@@LANDING-003">
      Transact makes paying small amounts of money for digital media fast and easy. Sign up now and get $3 in free credit!
    </p>
    <p i18n="@@LANDING-004">
      If you already have a Transact account, you can log into your Notd account now.
    </p>
    <div class="buttons">
      <button class="btn btn-primary sign-up" aria-label="Sign up with Transact" transact-auth register="true" showInfoModal="true" i18n="@@GLOBAL-SIGN-UP">Sign up with Transact</button>
      <button class="btn btn-primary" aria-label="Login with Transact" transact-auth i18n="@@GLOBAL-LOGIN">Login with Transact</button>
    </div>
  </div>
  <picture>
    <source media="(max-width: 900px)" srcset="../../assets/bg-2-medium.jpg">
    <source media="(max-width: 600px)" srcset="../../assets/bg-2-small.jpg">
    <img class="bg" src="../../assets/bg-2.jpg" alt="sign up">
  </picture>
</div>

<app-footer></app-footer>

<ng-template #most_popular_stream>
  <section
      class="stream-news-container"
      [ngClass]="'grid-type--' + stream.gridType"
      *ngFor="let stream of featuredChannels let i = index; let odd = odd">
      <div class="main-thumbnail-info-holder">
        <a class="stream-title-link" [routerLink]="stream.shortURLPath ? ['/s', stream.shortURLPath] : ['/streams', stream.id, 'view', stream.indexedName || stream.name || stream.id]" title="Go to {{stream.name}} stream!">{{stream.name}}</a>
        <div class="stream-description">
          <img-lazy-loading
            class="thumbnail"
            *ngIf="stream && stream.iconImageUrl && stream.iconImageThbs"
            [mainThumb]="stream.iconImageUrl"
            [thumbs]="stream.iconImageThbs"
            [url]="stream.shortURLPath ? ['/s', stream.shortURLPath] : ['/streams', stream.id, 'view', stream.indexedName || stream.name || stream.id]"
            [title]="'Read more about ' + stream.name"></img-lazy-loading>
          <h2 class="title">
            <a class="stream-link" [routerLink]="stream.shortURLPath ? ['/s', stream.shortURLPath] : ['/streams', stream.id, 'view', stream.indexedName || stream.name || stream.id]" title="Go to {{stream.name}} stream!">{{stream.name}}</a>
            <span class="time">{{stream.updated | date: 'MMM dd, yyyy'}}</span>
          </h2>
          <p class="description">{{stream.description}}</p>
          <a
            [routerLink]="stream.shortURLPath ? ['/s', stream.shortURLPath] : ['/streams', stream.id, 'view', stream.indexedName || stream.name || stream.id]" title="Read more from {{stream.name}}"
            class="btn-stream-get-more notd__button--v2 button--black">Read more from {{stream.name}}</a>
        </div>
      </div>
      <div
        class="steam-notes-wrapper"
        [ngClass]="{'single-note-display' : stream.gridType === 3 && stream.latestPosts && stream.latestPosts.length === 1, 'double--note' : stream.latestPosts && stream.latestPosts.length === 2 }">
        <div class="note-wrapper" *ngFor="let note of stream.latestPosts | slice:0:3; let i = index; let l = count">
          <img-lazy-loading
            class="note-img"
            *ngIf="note && note.thumbnails && note.thumbnailImage"
            [mainThumb]="note.thumbnailImage"
            [thumbs]="note.thumbnails"
            [url]="note.shortURLPath ? ['/n', note.shortURLPath] : ['/notes', note.id, note.indexedName || note.name || note.id]"
            [title]="'Read more about ' + note.name"></img-lazy-loading>
          <div class="note-details">
            <a
              [routerLink]="note.shortURLPath ? ['/n', note.shortURLPath] : ['/notes', note.id, note.indexedName || note.name || note.id]" title="Read about {{note.name}}"
              class="note-title">{{note.name}}</a>
            <p class="note-description">{{note.firstLeadWords}}</p>
            <div class="tags" *ngIf="note.price === 0">
              <!-- <span class="tag" *ngFor="let tag of note.tagLabels">{{tag}}</span> -->
              <span class="tag tag--free-note" *ngIf="note.price === 0">free note</span>
            </div>
            <div class="other-details" *ngIf="note.user">
              <a class="by-user" *ngIf="note.userDisplayName"
                [routerLink]="['/user', note.userId, 'profile']">
                <img
                  [alt]="note.user.displayName ? note.user.displayName : note.userDisplayName"
                  class="avatar"
                  *ngIf="note.user && note.user.profileImageUrl" [src]="note.user.profileImageUrl" />
                {{note.user.displayName ? note.user.displayName : note.userDisplayName}}
              </a>
              <span class="date">{{note.published || note.created | date: 'MMM dd, yyyy' }}</span>
            </div>
          </div>
        </div>
        <section class="content-loader" *ngIf="!stream.latestPosts">
          <span class="content-loader__spinner"></span>
          <p class="content-loader__label">Loading notes...</p>
        </section>
      </div>
      <read-more-from-category
        *ngFor="let p of readMorePositions"
        [title]="'Read more in ' + p.category"
        [useTextLinesLimit]="true"
        [category]="p.category"
        [showAfterContainer]="{showAfter: p.position, counter: i}"></read-more-from-category>
    </section>
</ng-template>
